import { JssConfig } from 'lib/config';

export const loadEdgeRuntimeConfig = (): JssConfig => ({
  sitecoreApiKey: process.env.SITECORE_API_KEY || 'no-api-key-set',
  sitecoreApiHost: process.env.SITECORE_API_HOST || 'http://cm',
  sitecoreSiteName: process.env.SITECORE_SITE_NAME || 'AdvocateHealthCom',
  graphQLEndpointPath: process.env.GRAPH_QL_ENDPOINT_PATH || '/sitecore/api/graph/edge',
  defaultLanguage: process.env.DEFAULT_LANGUAGE || 'en',
  graphQLEndpoint: process.env.GRAPH_QL_ENDPOINT || 'http://cm/sitecore/api/graph/edge',
  layoutServiceConfigurationName: process.env.LAYOUT_SERVICE_CONFIGURATION_NAME || 'sxa-jss',
  publicUrl: process.env.PUBLIC_URL || 'https://advocatehealthcom.enterprisedev.local',
  disableFetchSiteInformation: process.env.DISABLE_FETCH_SITE_INFORMATION || 'undefined',
  buildId: process.env.BUILD_ID || 'local-enterprisedev-rendering',
  appinsightsConnectionString: process.env.APPINSIGHTS_CONNECTION_STRING || '',
  renderingEnv: process.env.RENDERING_ENV,
  sites: process.env.SITES || '[]',
});
